import {ITheme} from 'contexts/ThemeContext';
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  minSize,
} from 'rn-responsive-styles';

export const getScrollViewWidth = (length: number) => {
  return {width: length * 33};
};

export default ({colors, typography}: ITheme) =>
  CreateResponsiveStyle(
    {
      container: {
        backgroundColor: colors.dirtyWhite,
      },
      leftContainer: {
        width: 250,
        paddingBottom: 20,
        zIndex: 1,
      },
      pickerContainerStyle: {
        width: 180,
      },
      dropDownListStyle: {
        width: 180,
        zIndex: 1,
      },
      chart: {
        marginTop: 20,
        flexDirection: 'column',
        paddingHorizontal: 30,
      },

      attentionWrapper: {
        height: 392,
        flexDirection: 'row',
      },

      attentionView: {
        flexDirection: 'column',
      },

      chartView: {
        flex: 1,
        maxHeight: 1000,
        boxShadow: `0px 4px 8px ${colors.shadowGrey}`,
      },

      tooltipView: {
        paddingLeft: 30,
      },

      tooltipWrapper: {
        paddingHorizontal: 12,
        paddingVertical: 8,
        backgroundColor: colors.lavenderWeb,
        borderRadius: 8,
        gap: 8,
        boxShadow: `0px 4px 0px ${colors.transparentPrimary}`,
      },
      tooltipItemWrapper: {
        alignItems: 'center',
        gap: 10,
        paddingBottom: 8,
        flexDirection: 'row',
        flexWrap: 'nowrap',
      },

      colorBlock: {
        width: 12,
        height: 12,
      },
      tooltipTextStyle: {
        lineHeight: 18,
        fontSize: 12,
        ...typography.interRegular,
      },
      toolipHeaderAndPercentTextStyle: {
        lineHeight: 18,
        fontSize: 12,
        ...typography.interSemiBold,
      },
      scrollViewStyle: {
        height: 410,
        flex: 1,
      },
      scrollViewContent: {
        height: 390,
      },
    },
    {
      [minSize(DEVICE_SIZES.SMALL_DEVICE)]: {},
    },
  )();
